import { EditorState, generateName } from "@common/Common";
import { CostSubtotalReadModel } from "@Quest/Financials/Costs/Domain/readmodels";

export class ExpenseAccountEditorViewModel
{
    state: EditorState = EditorState.Closed;

    id: string | null = null;
    name: string | null = null;
    classification: string | null = null;
    subtotalId: string | null = null;
    canEditName: boolean | null = null;
    canEditClassification: boolean | null = null;

    subtotals: CostSubtotalReadModel[] = [];

    get opened(): boolean { return this.state !== EditorState.Closed; }

    showCreator(subtotalId: string | null, subtotals: CostSubtotalReadModel[])
    {
        this.id = null;
        this.name = generateName("Expense");
        this.classification = "OpEx";
        this.subtotalId = subtotalId;
        this.canEditName = true;
        this.canEditClassification = true;

        this.subtotals = subtotals;

        this.state = EditorState.Creator;
    }

    showEditor(id: string, name: string, classification: string, subtotalId: string | null, canEditName: boolean, canEditClassification: boolean, subtotals: CostSubtotalReadModel[])
    {
        this.id = id;
        this.name = name;
        this.classification = classification;
        this.subtotalId = subtotalId;
        this.canEditName = canEditName;
        this.canEditClassification = canEditClassification;
        this.subtotals = subtotals;

        this.state = EditorState.Editor;
    }

    close()
    {
        this.state = EditorState.Closed;

        this.id = null;
        this.name = null;
        this.classification = null;
        this.subtotalId = null;
        this.canEditName = null;
        this.canEditClassification = null;
        this.subtotals = [];
    }
}

export class CreateExpenseAccountEventPayload
{
    name: string;
    classification: string;
    subtotalId: string | null;

    constructor(name: string, classification: string, subtotalId: string | null)
    {
        this.name = name;
        this.classification = classification;
        this.subtotalId = subtotalId;
    }
}

export class UpdateCostAccountEventPayload
{
    id: string;
    name: string;
    classification: string;
    subtotalId: string | null;

    constructor(id: string, name: string, classification: string, subtotalId: string | null)
    {
        this.id = id;
        this.name = name;
        this.classification = classification;
        this.subtotalId = subtotalId;
    }
}